import { useState } from "react";
import { useParams } from "react-router-dom";

import { Row, Col } from "react-bootstrap";
import { MdEdit } from "react-icons/md";

import DeleteModal from "../../../ui/DeleteModal";
import ErrorMessage from "../../../ui/ErrorMessage";
import PosameznoStroskovnoMestoEditForm from "./PosameznoStroskovnoMestoEditForm";

import { useDeleteStroskovnaMestaClanice } from "../../../../services/ProjectDetails/financeAPI";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const PosameznoStroskovnoMesto = ({ stroskovnoMestoPosamezno }) => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { project } = useProjectDetailsContext();

  const {
    mutate: deleteStroskovnoMesto,
    isPending: isPendingDelete,
    isError,
    error,
    reset: resetMutationError,
  } = useDeleteStroskovnaMestaClanice(id, stroskovnoMestoPosamezno?.id);

  const onDeleteClick = () => {
    deleteStroskovnoMesto({
      onSuccess: () => {
        setShowDeleteModal(false);
      },
      onError: () => {
        setTimeout(() => resetMutationError(), 3000);
        setShowDeleteModal(false);
      },
    });
  };

  return (
    <>
      {!isEditing ? (
        <Row className="align-items-center">
          <Col lg={5}>{stroskovnoMestoPosamezno?.stroskovnoMesto}</Col>
          <Col lg={5}>{stroskovnoMestoPosamezno?.stroskovniNosilec}</Col>
          <Col
            lg={2}
            className="d-flex justify-content-lg-end align-items-center gap-2"
          >
            <RoleGuard
              moduleKey={MODULES.PROJEKTI}
              roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
              vodilnaClanicaProjektaID={project?.clanicaID}
            >
              <button
                className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
                onClick={() => setIsEditing(true)}
              >
                <span className="d-flex align-items-center gap-1">
                  Uredi <MdEdit />
                </span>
              </button>
              <button
                className="btn btn-sm btn-outline-danger border-0"
                onClick={() => setShowDeleteModal(true)}
              >
                <span className="d-flex align-items-center gap-1">Izbriši</span>
              </button>
            </RoleGuard>
          </Col>
        </Row>
      ) : (
        <PosameznoStroskovnoMestoEditForm
          stroskovnoMestoPosamezno={stroskovnoMestoPosamezno}
          setIsEditing={setIsEditing}
        />
      )}

      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={onDeleteClick}
        title="Brisanje stroškovnega mesta"
        message="Ali ste prepričani, da želite izbrisati to stroškovno mesto?"
        isPending={isPendingDelete}
      />

      {isError && (
        <ErrorMessage message={error?.message || "Prišlo je do napake"} />
      )}
    </>
  );
};

export default PosameznoStroskovnoMesto;
